import { render } from "./AjouterConsultant.vue?vue&type=template&id=8f450fb6&scoped=true"
import script from "./AjouterConsultant.vue?vue&type=script&lang=js"
export * from "./AjouterConsultant.vue?vue&type=script&lang=js"

import "./AjouterConsultant.vue?vue&type=style&index=0&id=8f450fb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f450fb6"]])

export default __exports__